module.exports = __webpack_public_path__ + "static/media/Reciprocity Effect - superkitina-GIImjW5MzAA-unsplash.fabeac9c.jpg";